module.exports = __webpack_public_path__ + "7bac9bc53eb7fbef66f893f71e4bb468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/seta-saloes-01.jpg
// module id = 76
// module chunks = 0